import React from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';

import styles from './feedback-actions.style';
import { Button } from '../../../components/button/button';
import { useColors } from '../../../hooks';

interface FeedbackActionsProps {
  disabled: boolean;
  isLoading: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export default function FeedbackActions({
  disabled,
  isLoading,
  onClose,
  onSubmit,
}: FeedbackActionsProps) {
  const { t } = useTranslation();
  const colors = useColors();

  return (
    <View style={styles.container}>
      <Button
        textStyle={styles.buttonText}
        onPress={onSubmit}
        disabled={disabled}
        loading={isLoading}
      >
        {t('mobile.feedback.send')}
      </Button>

      <Button
        containerStyle={[
          styles.cancelButtonContainer,
          { backgroundColor: colors.grayLight },
        ]}
        textStyle={[styles.buttonText, { color: colors.gray }]}
        onPress={onClose}
      >
        {t('mobile.feedback.cancel')}
      </Button>
    </View>
  );
}
